import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    .section {
      padding: 25px 40px;
      margin-bottom: 150px;
      .finish {
        text-align: center;
        margin-bottom: 50px;
        .anticon-check-circle > svg {
          width: 70px;
          height: 70px;
          margin-top: 80px;
          margin-bottom: 50px;
          color: #80a445;
        }
        p {
          text-align: center;
          color: #80a445;
        }
      }
      .finish-step {
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-down-pdf {
          background-color: #a956ea;
          margin-right: 10px;
        }
        .btn-detail-register {
          background-color: #ff8a00;
        }
        .btn-fn-step {
          width: 338px;
          text-align: center;
          height: 60px;
          color: white !important;
          border-radius: 10px;
          border: none;
          box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
        }
      }
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .table {
      margin-top: 40px;
    }
  }
`;
